'use client';

import { useEffect } from 'react';

import useUserStore from '../state-stores/userStore';
import { initAmplitude, resetAmplitude, trackEvent } from '../amplitude';
// import { AmplitudeEvents } from '../amplitude/events';

export function AmplitudeProvider({ children }: { children: React.ReactNode }) {
  const { user } = useUserStore();

  // Initialize Amplitude and set user data
  useEffect(() => {
    if (user?.userId) {
      initAmplitude(user.userId);
    } else {
      initAmplitude(); // Initialize without user ID if no user
    }

    return () => {
      resetAmplitude(); // Clean up on user change or unmount
    };
  }, [user?.userId]);

  // Track page views
  // useEffect(() => {
  //   if (pathname) {
  //     trackEvent(AmplitudeEvents.page_viewed, { path: pathname });
  //   }
  // }, [pathname]);

  return <>{children}</>;
}
